import { render, staticRenderFns } from "./AddIndicator.vue?vue&type=template&id=0beb5704&scoped=true&"
import script from "./AddIndicator.vue?vue&type=script&lang=js&"
export * from "./AddIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AddIndicator.vue?vue&type=style&index=0&id=0beb5704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb5704",
  null
  
)

export default component.exports